import ru from './ru-Ru'
import en from './en-En'
const messages = {
  ru,
  en
};

export default messages